angular.module('impactx').factory('dataGen', DataGenerator);

DataGenerator.$inject = ['$http', '$config', '$securityManager', '$errorHandler', '$timeout', '$httpParamSerializerJQLike', '$q', 'LogoutTimerService', 'ToastService', 'ShutdownService'];

function DataGenerator($http, $config, $securityManager, $errorHandler, $timeout, $httpParamSerializerJQLike, $q, LogoutTimerService, ToastService, ShutdownService) {
    var self = this;
    var requestInProgress = 0,
        lastEndpoint,
        lastRequestTime,
        lastRequestHeaders = {};
    var cancelUpload = {};
    $http.defaults.withCredentials = true;

    function currentTime() {
        return +(new Date());
    }

    /**
     * Simplifies the popup property by removing the available entries.
     * This should reduce the data transmitted to the server.
     *
     * @param popupProperty popup property to simplify
     * @returns {{}} simplified popup property
     */
    this.slimDownPopup = function (popupProperty) {
        var result = {};

        if (popupProperty) {
            result = angular.copy(popupProperty, result);

            result.entries = [];

            return result;
        }

        return popupProperty;
    };

    /**
     * Simplifies relation property by removing available items, i.e. only assigned items will be in the
     * result.
     * @param relationProperty relation property to simplify
     * @return {*} simplified relation property.
     */
    this.slimDownRelation = function (relationProperty) {
        var result = {};

        if (relationProperty) {
            result = angular.copy(relationProperty, result);

            result.available = [];
            //Can be implemented more aggressively,
            // by removing (or assign "" to names, labels, ...) also values of entries and keeping only IDs
            return result;
        }

        return relationProperty;
    };

    /**
     * Simplifies given data.
     * @param data data to simplify for saving
     * @param properties object. Can have 2 lists with names of properties. 'popups' for popup properties and
     * 'relations' for relation properties
     * @return {*} simplified object
     */
    this.slimDown = function (data, properties) {
        var keyIdx, propertyName, keys, slimData = {};

        if (data && properties) {
            slimData = angular.copy(data, {});

            if (properties.popups && properties.popups.length) {
                keys = properties.popups;

                for (keyIdx = 0; keyIdx < keys.length; keyIdx++) {
                    propertyName = keys[keyIdx];

                    if (propertyName && slimData[propertyName] && slimData[propertyName].entries) {
                        slimData[propertyName] = this.slimDownPopup(slimData[propertyName]);
                    }
                }
            }

            if (properties.relations && properties.relations.length) {
                keys = properties.relations;

                for (keyIdx = 0; keyIdx < keys.length; keyIdx++) {
                    propertyName = keys[keyIdx];

                    if (propertyName && slimData[propertyName] && slimData[propertyName].relation) {
                        slimData[propertyName].relation = this.slimDownRelation(slimData[propertyName].relation);
                    }
                }
            }
            return slimData;
        }

        return data;
    };

    /**
     * Function to get data as JSONP
     * @param scope Object the requested data is attached to
     * @param params Parameters for the request
     * @param endpoint Endpoint the request goes to
     * @param callbackFunc Function which is called after the request was successful
     * @returns promise of the request
     */
    this.get = function (scope, params, endpoint, callbackFunc, async) {
        var defer = $q.defer();

        lastEndpoint = endpoint;
        lastRequestTime = currentTime();

        prepareRequest(callbackFunc, endpoint, params, async, true);
        var res = $http.get($config.sourceURL + endpoint, {
            params: params,
            data: '',
            headers: {
                'Content-Type': 'application/json',
                'token' : $securityManager.getToken()
            },
            ignoreLoadingBar: async
        }).catch(angular.noop);
        addHandlers(res, scope, callbackFunc, async, defer);
        return defer.promise;
    };

    this.getDataFromOtherSystem = function (scope, params, endpoint, sourceUrl) {
        var defer = $q.defer();

        lastEndpoint = endpoint;
        lastRequestTime = currentTime();

        prepareRequest(undefined, endpoint, params, undefined, true);
        var res = $http.get(sourceUrl + endpoint, {
            params: params,
            data: '',
            headers: {
                'Content-Type': 'application/json',
                'token' : $securityManager.getToken()
            },
            ignoreLoadingBar: undefined
        }).catch(angular.noop);
        addHandlers(res, scope, undefined, undefined, defer);
        return defer.promise;
    };

    /**
     * Function to post as JSON
     * @param scope Object the requested data is attached to
     * @param params Parameters for the request
     * @param endpoint Endpoint the request goes to
     * @param callbackFunc Function which is called after the request was successful
     * @param config config parameters
     * @param async true if this should be an async call
     * @param closeOpenDialogsOnError true if all open mdDialogs should be closed on error before opening the error dialog
     * @returns promise of the request
     * @deprecated use {@link postAsForm }
     */
    this.post = function (scope, params, endpoint, callbackFunc, config, async, closeOpenDialogsOnError) {
        var defer = $q.defer();
        prepareRequest(callbackFunc, endpoint, params, async);
        params.callback = "VEENION_CALLBACK";
        var res = $http.post($config.sourceURL + endpoint, params, config).catch(angular.noop);
        addHandlers(res, scope, callbackFunc, async, defer, closeOpenDialogsOnError);

        return defer.promise;
    };

    /**
     * Checks whether the given endpoint was also the last endpoint requested.
     * @param endpointToCheck endpoint to check
     * @param timeMs (optional) minimal time for the request, i.e. if within the given time-period the
     * request has been made to the given endpoint then return true
     * @return {boolean} true when the same endpoint has been request (possibly within given period).
     */
    this.isLastEndpointRequested = function (endpointToCheck, timeMs) {
        var current;
        if (lastEndpoint && (lastEndpoint === endpointToCheck)) {
            if (timeMs > 0 && lastRequestTime > 0) {
                current = currentTime();

                return timeMs >= (current - lastRequestTime);
            }

            return true;
        }
        return false;
    };

    /**
     * Function to post data as form
     * @param scope Object the requested data is attached to
     * @param params Parameters for the request
     * @param endpoint Endpoint the request goes to
     * @param sourceUrl the url to call
     * @returns promise of the request
     */
    this.postAsFormOtherSystem = function (scope, params, endpoint, sourceUrl) {
        var res, httpTimeout,
            defer, data, requestConfig;

        data = transformData(params);

        prepareRequest(null, endpoint, data, false);
        defer = $q.defer();

        lastEndpoint = endpoint;
        lastRequestTime = currentTime();

        requestConfig = {
            ignoreLoadingBar: false,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };


        res = $http.post(sourceUrl + endpoint, $httpParamSerializerJQLike(data), requestConfig).catch(angular.noop);

        addHandlers(res, scope, null, false, defer, false, false);

        return defer.promise;
    };

    /**
     * Function to post data as form
     * @param scope Object the requested data is attached to
     * @param params Parameters for the request
     * @param endpoint Endpoint the request goes to
     * @param canAbort (optional) flag or promise, if you like the promise to be able to cancel.
     *                  if you pass a promise you have to cancel it yourself, otherwise call this.cancelPromise
     * @param async flag if UI is blocked or not
     * @param hideErrors hides error dialog (not critical or warnings)
     * @param awaitWarnings if true, the returned promise only resolves after the user dismissed
     *                      any shown warning (e.g. "maximum order quantity exceeded"), so follow-up
     *                      dialogs opened in .then() do not tear the warning down. See IOBL-15395.
     * @returns promise of the request
     */
    this.postAsForm = function (scope, params, endpoint, canAbort, async, hideErrors, awaitWarnings) {
        var res, httpTimeout,
            defer, data, requestConfig;

        data = transformData(params);

        prepareRequest(null, endpoint, data, async);
        defer = $q.defer();

        lastEndpoint = endpoint;
        lastRequestTime = currentTime();

        requestConfig = {
            ignoreLoadingBar: async,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };

        if (canAbort) {
            if (!canAbort.then) {
                httpTimeout = $q.defer();
                requestConfig.timeout = httpTimeout.promise;
            }
            else {
                requestConfig.timeout = canAbort;
            }
        }

        res = $http.post($config.sourceURL + endpoint, $httpParamSerializerJQLike(data), requestConfig).catch(angular.noop);
        async = !!async;

        addHandlers(res, scope, null, async, defer, false, hideErrors, awaitWarnings);

        if (canAbort) {
            defer.promise._httpTimeout = httpTimeout;
        }

        return defer.promise;
    };

    this.getDataForPostForm = function (params) {
        var data = transformData(params);
        appendToken(data, false);
        return $httpParamSerializerJQLike(data);
    }
    /**
     * Cancels the given promise. Currently only requests made by .postAsForm can be cancelled.
     * @param promiseToCancel promise which needs to be cancelled
     */
    this.cancelPromise = function (promiseToCancel) {
        if (promiseToCancel && promiseToCancel._httpTimeout && promiseToCancel._httpTimeout.resolve) {
            promiseToCancel._httpTimeout.resolve({manualAbort: true});
        }
    };

    /**
     * Returns true if a request is currently in progress
     * @returns {boolean}
     */
    this.requestInProgress = function () {
        return requestInProgress > 0;
    };

    this.lastRequestHeaders = function () {
        return self.lastRequestHeaders;
    };

    /**
     * Transform the given parameters into a form that the backend end translate to DTOs,
     * this includes transforming them to Strings
     * @param params Parameters to transform
     * @returns Transformed data, normal parameters are transformed to string, arrays are transformed to arrays of strings
     */
    function transformData(params) {
        var data = {};
        angular.forEach(params, function (value, key) {
            if (Object.prototype.toString.call(value) === '[object Array]') {
                var arrayData = [];
                angular.forEach(value, function (value2, key) {
                    arrayData.push(angular.toJson(value2))
                });
                data[key] = arrayData;
            }
            else {
                data[key] = (typeof (value) === 'string' || value instanceof String) ? value : angular.toJson(value);
            }
        });
        return data;
    }

    function addHandlers(res, scope, callbackFunc, async, defer, closeOpenDialogsOnError, hideErrors, awaitWarnings) {
        res.then(function (data, status, headers, config) {
            if (data && data.headers) {
                self.lastRequestHeaders = data.headers();
            }

            if (!data) {
                defer.reject(impactX.isDefined(data, 'data'));
            }
            else {
                var result = handleSuccess(data.data, scope, callbackFunc, async, closeOpenDialogsOnError, hideErrors, awaitWarnings);
                if (result.hasErrors) {
                    defer.reject(impactX.isDefined(data, 'data'));
                } else {
                    // When awaitWarnings is set, warningsDone resolves only after the user
                    // dismissed the shown warning; otherwise it is already resolved.
                    result.warningsDone.then(function () {
                        defer.resolve(impactX.isDefined(data, 'data'));
                    });
                }
            }
        }, function (data) {
            if (isManualRequestCancel(defer)) {
                //No error message when manually aborted!
                if (!async) {
                    requestInProgress--;
                }
                return;
            }
            handleError(data, async);
        });
    }

    /**
     * Checks whether the given deferred object is used for manual cancellation
     * @param defer deferred object
     * @return {*} truthy value
     */
    function isManualRequestCancel(defer) {
        return impactX.isDefined(defer, 'promise._httpTimeout.promise.$$state.value.manualAbort');
    }

    function handleSuccess(data, scope, callbackFunc, async, closeOpenDialogsOnError, hideErrors, awaitWarnings) {
        if (!async) {
            requestInProgress--;
        }
        var hasErrors = false;
        var warningsDone = $q.when();
        if (data.data) {
            var token = data.data.token;
            if (token) {
                // only reset logout timer if the token was updated at backend
                LogoutTimerService.checkNewData(self, data);
                $securityManager.setToken(token);
                data.data.token = undefined;
            }

            scope.data = data.data;
            scope.trns = data.trns;
            scope.printTokens = data.printTokens;
        }
        if (data.shutdownChecked) {
            ShutdownService.setShutdownMessage(data.shutdown);
        }

        if (data.criticalErrors && data.criticalErrors.length > 0) {
            $errorHandler.showCriticalErrors(data.criticalErrors, impactX.isDefined(data.criticalErrors[0], "stackTrace"));
        }
        else {
            if (data.authErrors && data.authErrors.length > 0) {
                if ($securityManager.getToken()) {
                    $securityManager.deleteTokenAndRedirect();
                }
                hasErrors = true;
            }
            if (data.errors && data.errors.length > 0) {
                hasErrors = true;
                if (!hideErrors) {
                    $errorHandler.showErrors(data.errors, null, null, closeOpenDialogsOnError);
                }
            }
            if (data.warnings && data.warnings.length > 0) {
                var shownWarnings = $errorHandler.showWarnings(data.warnings);
                if (awaitWarnings) {
                    // Gate promise resolution on the user dismissing the warning. Continue
                    // regardless of "Weiter" (hide) or click-outside (cancel). See IOBL-15395.
                    warningsDone = shownWarnings.then(angular.noop, angular.noop);
                }
            }
        }

        if (callbackFunc && !hasErrors) {
            callbackFunc(data);
        }

        return { hasErrors: hasErrors, warningsDone: warningsDone };
    }

    function showCallbackWarning(callbackFunc, endpoint) {
        if (callbackFunc) {
            console.log("GETDATA: Please do not use callback here when calling '" + endpoint + "'. Please use the promise API")
        }
    }

    function handleError(data, async) {
        var errorText = "Error while contacting source system!";
        if (!async) {
            requestInProgress--;
        }
        if (impactX.isDefined(data, "statusText")) {
            errorText = "Error " + data.status + ": " + data.statusText;
        }
        $errorHandler.showCriticalErrors([{error: errorText}], impactX.isDefined(data, "data.stackTrace"));
    }

    function appendToken(params, hideSecurityToken) {
        if (!hideSecurityToken) {
            params.token = $securityManager.getToken();
        }
        params.jsonpCallbackParam = $config.callback;
    }

    function prepareRequest(callbackFunc, endpoint, params, async, hideSecurityToken) {
        params.ignoreLoadingBar = async;
        showCallbackWarning(callbackFunc, endpoint);
        appendToken(params, hideSecurityToken);
    }

    self.uploadFile = function (formData, uri, showLoadingBar, hideFailedToast) {
        var defer = $q.defer();
        cancelUpload = $q.defer();

        ToastService.openUploadToast();
        defer.notify = updateUploadProgress;
        var requestConfig = {
            method: 'POST',
            data: createFormDataObject(formData),
            url: $config.sourceURL + uri,
            headers: {'Content-Type': undefined},
            timeout: cancelUpload.promise,
            ignoreLoadingBar: !showLoadingBar,
            uploadEventHandlers: {
                progress: function (e) {
                    defer.notify(e.loaded * 100 / e.total);
                }
            }
        };

        appendToken(requestConfig);
        $http(requestConfig).then(function (response) {
            if (!handleUploadErrors(response)) {
                var token = impactX.isDefined(response, 'data.data.token');
                if (token) {
                    $securityManager.setToken(token);
                    response.data.data.token = undefined;
                    response.data.data.tokenValidSeconds = undefined;
                }
                defer.resolve(response.data);
            }
            else {
                if (!hideFailedToast)
                {
                    defer.notify(-1);
                }
                defer.reject(response.data);
            }
        }, function () {
            defer.reject();
        });
        return defer.promise;
    };

    self.cancelUpload = function () {
        return cancelUpload.resolve();
    };

    function createFormDataObject(formData) {
        var result = new FormData();

        for (var property in formData) {
            if (formData.hasOwnProperty(property)) {
                if (Array.isArray(formData[property])) {
                    result.append(property, JSON.stringify(formData[property]));
                }
                else {
                    result.append(property, formData[property]);
                }
            }
        }
        result.append('token', $securityManager.getToken());
        result.append('callback', $config.callback);
        return result;
    }

    function updateUploadProgress(progress) {
        ToastService.setUploadProgress(Math.floor(progress));
    }

    function handleUploadErrors(response) {
        var hasErrors = false;
        var warnings = impactX.isDefined(response, 'data.warnings');
        var errors = impactX.isDefined(response, 'data.errors');
        var criticalErrors = impactX.isDefined(response, 'data.criticalErrors');
        if (warnings && warnings.length > 0) {
            hasErrors = true;
            $errorHandler.showWarnings(warnings);
        }
        if (errors && errors.length > 0) {
            hasErrors = true;
            $errorHandler.showErrors(errors);
        }
        if (criticalErrors && criticalErrors.length > 0) {
            hasErrors = true;
            $errorHandler.showCriticalErrors(criticalErrors);
        }

        return hasErrors;
    }

    /**
     * Erstellt ein Kontext-Objekt um Server-Anfragen zu machen um Listen zu erhalten.
     * @returns 
     */
    function createServerListRequestContext() {
        return {
            defer: {}
        };
    }

    /**
     * Diese Funktion wurde aus ix.serverside-list.controller.js genommen.
     * @param {*} endpoint 
     * @param {*} params 
     * @param {*} responseScope 
     * @param {*} requestContext 
     * @returns 
     */
    function makeServerListRequest(endpoint, params, responseScope, requestContext) {
        if (typeof requestContext.defer.resolve === 'function') {
            requestContext.defer.resolve();
        }
        requestContext.defer = $q.defer();

        return this.postAsForm(
            responseScope, 
            params, 
            endpoint, 
            requestContext.defer.promise, 
            false
        );
    }

    return {
        getData: this.get,
        getDataFromOtherSystem: this.getDataFromOtherSystem,
        postAsFormOtherSystem: this.postAsFormOtherSystem,
        post: this.post,
        postAsForm: this.postAsForm,
        requestInProgress: this.requestInProgress,
        slimDownPopup: this.slimDownPopup,
        slimDownRelation: this.slimDownRelation,
        slimDown: this.slimDown,
        cancel: this.cancelPromise,
        isLastEndpointRequested: this.isLastEndpointRequested,
        lastRequestHeaders: this.lastRequestHeaders,
        uploadFile: this.uploadFile,
        cancelUpload: this.cancelUpload,
        createServerListRequestContext: createServerListRequestContext,
        makeServerListRequest: makeServerListRequest,
        getDataForPostForm: this.getDataForPostForm,
    };
}